import type { ComponentType, ReactNode, SVGProps } from "react";
import {
  Button,
  Icon as ChakraIcon,
  Tooltip,
  useToken,
} from "@chakra-ui/react";
import { useMatch, useResolvedPath } from "react-router-dom";
import LockIcon from "assets/icons/medium/lock.svg?react";
import { LinkPreserveSearch } from "components/link-preserve-search";

export function LeftNavigationMenuItem({
  label,
  path,
  Icon,
  isLocked = false,
  isLockedTooltip,
}: {
  label: ReactNode;
  path: string;
  Icon?: ComponentType<SVGProps<SVGSVGElement>>;
  isLocked?: boolean;
  isLockedTooltip?: string;
}) {
  const resolved = useResolvedPath(path, { relative: "route" });
  const match = useMatch({ path: resolved.pathname });
  const lockIconColor = useToken("colors", "client.navigation.text.secondary");

  return (
    <Tooltip
      label={isLockedTooltip}
      hasArrow
      arrowSize={15}
      isDisabled={!isLocked}
      placement={"right"}
    >
      <Button
        as={isLocked ? undefined : LinkPreserveSearch}
        to={path}
        {...(isLocked ? {} : { keyWhitelist: ["property_id"] })}
        color={"client.navigation.text.primary"}
        w={"100%"}
        pl={3}
        py={6}
        fontWeight={"medium"}
        lineHeight={"24px"}
        fontSize={"lg"}
        invert={1}
        overflow={"hidden"}
        _hover={
          isLocked
            ? undefined
            : {
                backgroundColor: "client.navigation.hover.background",
                color: "client.navigation.hover.text",
              }
        }
        _active={{
          backgroundColor: "client.navigation.active.background",
          color: "client.navigation.active.text",
        }}
        justifyContent={"flex-start"}
        leftIcon={
          Icon ? <ChakraIcon as={Icon} boxSize={5} ml={1} mr={2} /> : undefined
        }
        rightIcon={
          isLocked ? (
            <ChakraIcon
              as={LockIcon}
              boxSize={5}
              pos={"absolute"}
              top={3}
              right={2}
              css={{
                "& path": {
                  stroke: lockIconColor,
                },
              }}
            />
          ) : undefined
        }
        variant={"ghost"}
        isActive={!!match}
        isDisabled={isLocked}
      >
        {label}
      </Button>
    </Tooltip>
  );
}
